import { render, staticRenderFns } from "./CBtn.vue?vue&type=template&id=71ae8ea9"
import script from "./CBtn.vue?vue&type=script&lang=js"
export * from "./CBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71ae8ea9')) {
      api.createRecord('71ae8ea9', component.options)
    } else {
      api.reload('71ae8ea9', component.options)
    }
    module.hot.accept("./CBtn.vue?vue&type=template&id=71ae8ea9", function () {
      api.rerender('71ae8ea9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CBtn.vue"
export default component.exports